export class ValidationService {
    constructor(registryProvider) {
        this.validationRegistries = new Map();
        if (!registryProvider) {
            throw new Error('A Validation Registry provider is not set');
        }
        this.registryProvider = registryProvider;
    }
    createEntityValidator(entity, validatorFunctions) {
        if (!this.validationRegistries.has(entity)) {
            this.validationRegistries.set(entity, this.registryProvider());
        }
        const existingRegistry = this.validationRegistries.get(entity);
        if (validatorFunctions && !existingRegistry.isInitialized()) {
            Object.entries(validatorFunctions).forEach(([name, validatorFn]) => {
                existingRegistry.register(name, validatorFn);
            });
            existingRegistry.markInitialized();
        }
        return existingRegistry;
    }
    clearRegistry(entity) {
        this.validationRegistries.delete(entity);
    }
}
//# sourceMappingURL=validationService.js.map